import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { withInRules, allCancellationTrans } from '~helpers/longtail-cancellation-period';
import { useTranslation } from 'react-i18next';

const FreeCancellationPolicyRule = ({ category, type }) => {
  const { t } = useTranslation();
  const [cardHeight, setCardHeight] = useState('auto');
  const content = allCancellationTrans?.[type]?.[category];

  useEffect(() => {
    const getCardHeight = () => {
      const keppelCard = document.querySelector('.free-cancellation-policy-rule__card--keppel');
      if (keppelCard) {
        setCardHeight(keppelCard.offsetHeight);
      }
    };

    getCardHeight();
    window.addEventListener('resize', getCardHeight);

    return () => {
      window.removeEventListener('resize', getCardHeight);
    };
  }, []);

  return (
    <div className="free-cancellation-policy-rule">
      {content && (
        <div style={{ height: cardHeight }} className="free-cancellation-policy-rule__card">
          <h3 className="free-cancellation-policy-rule__card-title">{t(content.title)}</h3>

          {content.desc && (
            <span className="free-cancellation-policy-rule__card-text">{t(content.desc)}</span>
          )}
          {content.hasRules && (
            <div className="free-cancellation-policy-rule__rules">
              {Object.keys(withInRules).map(rule => (
                <div className="free-cancellation-policy-rule__rule" key={rule}>
                  <div className="free-cancellation-policy-rule__img">
                    <LegacyIcon
                      type={withInRules[rule].icon}
                      className={classNames('free-cancellation-policy-rule__icon', {
                        'free-cancellation-policy-rule__icon--close':
                          withInRules[rule].icon === 'close',
                      })}
                    />
                  </div>
                  <span className="free-cancellation-policy-rule__label">
                    {t(withInRules[rule].text)}
                    {withInRules[rule].tip && (
                      <Tooltip placement="top" title={t(withInRules[rule].tip)}>
                        <QuestionCircleOutlined className="free-cancellation-policy-rule__tooltip-icon" />
                      </Tooltip>
                    )}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FreeCancellationPolicyRule;
